/** Тренировки, планировщик, формы планов — экраны кроме профиля/оплат/клиентов. */
export const SURFACES_RU = {
  'trainer.loadingWorkouts': 'Загрузка тренировок…',
  'trainer.workoutsOn': 'Тренировки на {date}',
  'trainer.allWorkouts': 'Все тренировки',
  'trainer.showCancelled': 'Показать отменённые',
  'trainer.noWorkouts': 'Нет тренировок',
  'trainer.noWorkoutsHint': 'На выбранную дату занятий нет.',
  'trainer.addWorkout': 'Добавить тренировку',
  'trainer.online': 'Онлайн',
  'trainer.participants': 'Участники:',
  'trainer.walletUnpaid': 'Не оплачено',
  'trainer.walletLastPaid': 'Последнее оплаченное занятие',
  'trainer.selfTraining': 'Самотрен',
  'trainer.clientFallback': 'Клиент',
  'trainer.clientsCount': '{n} клиентов',

  'plan.muscle.chest': 'Грудь',
  'plan.muscle.back': 'Спина',
  'plan.muscle.legs': 'Ноги',
  'plan.muscle.shoulders': 'Плечи',
  'plan.muscle.arms': 'Руки',
  'plan.muscle.core': 'Пресс',
  'plan.muscle.cardio': 'Кардио',
  'plan.muscle.other': 'Другое',

  'plan.sets': 'Подходы',
  'plan.setIndex': 'Подход {n}',
  'plan.repsPlaceholder': 'Повторения',
  'plan.weightPlaceholder': 'Вес (кг)',
  'plan.addSet': 'Добавить подход',
  'plan.comment': 'Комментарий',
  'plan.commentExercisePlaceholder': 'Комментарий к упражнению…',
  'plan.kg': 'кг',

  'plan.nameRequired': 'Введите название плана',
  'plan.saveError': 'Не удалось сохранить план',
  'plan.toastSavedNew': 'План сохранён',
  'plan.toastSavedEdit': 'Изменения в плане сохранены',
  'plan.editTitle': 'Редактирование плана {name}',
  'plan.newTitle': 'Новый план',
  'plan.saving': 'Сохранение…',
  'plan.nameLabel': 'Название плана *',
  'plan.namePlaceholder': 'Например: Спина и бицепс',
  'plan.descLabel': 'Краткое описание',
  'plan.descPlaceholder': 'Описание плана тренировок',
  'plan.exercises': 'Упражнения',
  'plan.addExercise': 'Добавить упражнение',
  'plan.addExerciseTitle': 'Добавить упражнение',
  'plan.pickExercise': 'Выберите упражнение',
  'plan.pickExercisePlaceholder': 'Выберите упражнение…',
  'plan.searchExercises': 'Поиск упражнений…',
  'plan.filterAll': 'Все',
  'plan.noExercisesFound': 'Упражнения не найдены',
  'exerciseRef.deleteTitle': 'Удалить упражнение?',
  'exerciseRef.deleteConfirm':
    'Вы уверены, что хотите удалить упражнение «{name}»? Это действие нельзя отменить.',
  'exerciseRef.toastSavedNew': 'Упражнение добавлено',
  'exerciseRef.toastSavedEdit': 'Упражнение сохранено',
  'plan.noExercisesInPlan': 'Нет упражнений в плане',
  'plan.noExercisesHint': 'Нажмите «Добавить упражнение», чтобы начать',

  'planner.weekFallback': 'Неделя',
  'planner.showEarlier': 'Показать раньше',
  'planner.hideEarlier': 'Скрыть 0:00–9:00',
  'planner.showLater': 'Показать позже',
  'planner.hideLater': 'Скрыть 21:00–0:00',
  'planner.mon': 'Пн',
  'planner.tue': 'Вт',
  'planner.wed': 'Ср',
  'planner.thu': 'Чт',
  'planner.fri': 'Пт',
  'planner.sat': 'Сб',
  'planner.sun': 'Вс',

  'date.pickWeek': 'Выберите неделю',
  'date.pickDate': 'Выбрать дату',
  'date.loadingDays': 'Загрузка дней недели… ({n})',
  'date.goToToday': 'Сегодня',
  'date.goToTodayHint': 'Перейти на текущий день',
  'date.prevWeek': 'Предыдущая неделя',
  'date.nextWeek': 'Следующая неделя',

  'clientDash.myWorkouts': 'Мои тренировки',
  'clientDash.workoutsOn': 'Тренировки на {date}',
  'clientDash.loadingSr': 'Загрузка…',
  'clientDash.noWorkouts': 'Нет тренировок на выбранную дату',
  'clientDash.exercises': 'Упражнения:',
};

export const SURFACES_EN = {
  'trainer.loadingWorkouts': 'Loading workouts…',
  'trainer.workoutsOn': 'Workouts on {date}',
  'trainer.allWorkouts': 'All workouts',
  'trainer.showCancelled': 'Show cancelled & moved',
  'trainer.noWorkouts': 'No workouts',
  'trainer.noWorkoutsHint': 'Nothing scheduled for this day.',
  'trainer.addWorkout': 'Add workout',
  'trainer.online': 'Online',
  'trainer.participants': 'Participants:',
  'trainer.walletUnpaid': 'Unpaid',
  'trainer.walletLastPaid': 'Last prepaid session',
  'trainer.selfTraining': 'Solo',
  'trainer.clientFallback': 'Client',
  'trainer.clientsCount': '{n} clients',

  'plan.muscle.chest': 'Chest',
  'plan.muscle.back': 'Back',
  'plan.muscle.legs': 'Legs',
  'plan.muscle.shoulders': 'Shoulders',
  'plan.muscle.arms': 'Arms',
  'plan.muscle.core': 'Core',
  'plan.muscle.cardio': 'Cardio',
  'plan.muscle.other': 'Other',

  'plan.sets': 'Sets',
  'plan.setIndex': 'Set {n}',
  'plan.repsPlaceholder': 'Reps',
  'plan.weightPlaceholder': 'Weight (kg)',
  'plan.addSet': 'Add set',
  'plan.comment': 'Note',
  'plan.commentExercisePlaceholder': 'Exercise note…',
  'plan.kg': 'kg',

  'plan.nameRequired': 'Enter a plan name',
  'plan.saveError': 'Couldn’t save plan',
  'plan.toastSavedNew': 'Plan saved',
  'plan.toastSavedEdit': 'Plan updated',
  'plan.editTitle': 'Edit plan · {name}',
  'plan.newTitle': 'New plan',
  'plan.saving': 'Saving…',
  'plan.nameLabel': 'Plan name *',
  'plan.namePlaceholder': 'e.g. Back & biceps',
  'plan.descLabel': 'Short description',
  'plan.descPlaceholder': 'What this plan is for',
  'plan.exercises': 'Exercises',
  'plan.addExercise': 'Add exercise',
  'plan.addExerciseTitle': 'Add exercise',
  'plan.pickExercise': 'Choose exercise',
  'plan.pickExercisePlaceholder': 'Pick an exercise…',
  'plan.searchExercises': 'Search exercises…',
  'plan.filterAll': 'All',
  'plan.noExercisesFound': 'No exercises found',
  'exerciseRef.deleteTitle': 'Delete exercise?',
  'exerciseRef.deleteConfirm': 'Delete “{name}”? This can’t be undone.',
  'exerciseRef.toastSavedNew': 'Exercise added',
  'exerciseRef.toastSavedEdit': 'Exercise saved',
  'plan.noExercisesInPlan': 'No exercises in this plan',
  'plan.noExercisesHint': 'Tap “Add exercise” to get started',

  'planner.weekFallback': 'Week',
  'planner.showEarlier': 'Show earlier hours',
  'planner.hideEarlier': 'Hide 0:00–9:00',
  'planner.showLater': 'Show late hours',
  'planner.hideLater': 'Hide 21:00–0:00',
  'planner.mon': 'Mo',
  'planner.tue': 'Tu',
  'planner.wed': 'We',
  'planner.thu': 'Th',
  'planner.fri': 'Fr',
  'planner.sat': 'Sa',
  'planner.sun': 'Su',

  'date.pickWeek': 'Pick a week',
  'date.pickDate': 'Pick date',
  'date.loadingDays': 'Loading week days… ({n})',
  'date.goToToday': 'Today',
  'date.goToTodayHint': 'Go to today',
  'date.prevWeek': 'Previous week',
  'date.nextWeek': 'Next week',

  'clientDash.myWorkouts': 'My workouts',
  'clientDash.workoutsOn': 'Workouts on {date}',
  'clientDash.loadingSr': 'Loading…',
  'clientDash.noWorkouts': 'No workouts on this day',
  'clientDash.exercises': 'Exercises:',
};

export const SURFACES_ES = {
  'trainer.loadingWorkouts': 'Cargando entrenos…',
  'trainer.workoutsOn': 'Entrenos del {date}',
  'trainer.allWorkouts': 'Todos los entrenos',
  'trainer.showCancelled': 'Mostrar cancelados y reprogramados',
  'trainer.noWorkouts': 'Sin entrenos',
  'trainer.noWorkoutsHint': 'No hay nada programado este día.',
  'trainer.addWorkout': 'Añadir entreno',
  'trainer.online': 'Online',
  'trainer.participants': 'Participantes:',
  'trainer.walletUnpaid': 'Sin pagar',
  'trainer.walletLastPaid': 'Última sesión prepagada',
  'trainer.selfTraining': 'Solo',
  'trainer.clientFallback': 'Cliente',
  'trainer.clientsCount': '{n} clientes',

  'plan.muscle.chest': 'Pecho',
  'plan.muscle.back': 'Espalda',
  'plan.muscle.legs': 'Piernas',
  'plan.muscle.shoulders': 'Hombros',
  'plan.muscle.arms': 'Brazos',
  'plan.muscle.core': 'Core',
  'plan.muscle.cardio': 'Cardio',
  'plan.muscle.other': 'Otro',

  'plan.sets': 'Series',
  'plan.setIndex': 'Serie {n}',
  'plan.repsPlaceholder': 'Reps',
  'plan.weightPlaceholder': 'Peso (kg)',
  'plan.addSet': 'Añadir serie',
  'plan.comment': 'Nota',
  'plan.commentExercisePlaceholder': 'Nota del ejercicio…',
  'plan.kg': 'kg',

  'plan.nameRequired': 'Pon un nombre al plan',
  'plan.saveError': 'No se pudo guardar el plan',
  'plan.toastSavedNew': 'Plan guardado',
  'plan.toastSavedEdit': 'Cambios del plan guardados',
  'plan.editTitle': 'Editar plan · {name}',
  'plan.newTitle': 'Plan nuevo',
  'plan.saving': 'Guardando…',
  'plan.nameLabel': 'Nombre del plan *',
  'plan.namePlaceholder': 'p. ej. Espalda y bíceps',
  'plan.descLabel': 'Descripción breve',
  'plan.descPlaceholder': 'Para qué sirve este plan',
  'plan.exercises': 'Ejercicios',
  'plan.addExercise': 'Añadir ejercicio',
  'plan.addExerciseTitle': 'Añadir ejercicio',
  'plan.pickExercise': 'Elegir ejercicio',
  'plan.pickExercisePlaceholder': 'Elige un ejercicio…',
  'plan.searchExercises': 'Buscar ejercicios…',
  'plan.filterAll': 'Todos',
  'plan.noExercisesFound': 'No hay ejercicios',
  'exerciseRef.deleteTitle': '¿Eliminar ejercicio?',
  'exerciseRef.deleteConfirm': '¿Eliminar «{name}»? No se puede deshacer.',
  'exerciseRef.toastSavedNew': 'Ejercicio añadido',
  'exerciseRef.toastSavedEdit': 'Ejercicio guardado',
  'plan.noExercisesInPlan': 'Este plan no tiene ejercicios',
  'plan.noExercisesHint': 'Pulsa «Añadir ejercicio» para empezar',

  'planner.weekFallback': 'Semana',
  'planner.showEarlier': 'Ver horas tempranas',
  'planner.hideEarlier': 'Ocultar 0:00–9:00',
  'planner.showLater': 'Ver tarde',
  'planner.hideLater': 'Ocultar 21:00–0:00',
  'planner.mon': 'Lu',
  'planner.tue': 'Ma',
  'planner.wed': 'Mi',
  'planner.thu': 'Ju',
  'planner.fri': 'Vi',
  'planner.sat': 'Sá',
  'planner.sun': 'Do',

  'date.pickWeek': 'Elegir semana',
  'date.pickDate': 'Elegir fecha',
  'date.loadingDays': 'Cargando días de la semana… ({n})',
  'date.goToToday': 'Hoy',
  'date.goToTodayHint': 'Ir al día de hoy',
  'date.prevWeek': 'Semana anterior',
  'date.nextWeek': 'Semana siguiente',

  'clientDash.myWorkouts': 'Mis entrenos',
  'clientDash.workoutsOn': 'Entrenos del {date}',
  'clientDash.loadingSr': 'Cargando…',
  'clientDash.noWorkouts': 'No hay entrenos este día',
  'clientDash.exercises': 'Ejercicios:',
};
